export enum BioKindsEnum {
  NONE = '0',
  EUNONEU = '1',
  EU = '2',
  NONEU = '3'
}

export enum BioKindsEnumTranslations {
  NONE = 'Kein Siegel',
  EUNONEU = 'EU / Nicht-EU-Landwirtschaft',
  EU = 'EU-Landwirtschaft',
  NONEU = 'Nicht-EU-Landwirtschaft',
}
